import Vue from "vue";
import Vuex from "vuex";
import auth from "./modules/auth";
import bankpay from "./modules/bankpay";
import packsreceipts from "./modules/packsreceipts";
import relationship from "./modules/relationship";
import assignoperators from "./modules/assignoperators";
import controlpacks from "./modules/controlpacks";
import controlinetpays from "./modules/controlinetpays";
import subscribers from "./modules/subscribers";
import subscribercard from "./modules/subscribercard";
import payment from "./modules/payment";
import infopack from "./modules/infopack";
import packs from "./modules/packs";
import gridcontextmenu from "./modules/gridcontextmenu";
import errorpayments from "./modules/errorpayments";
import acceptedShipment from "./modules/acceptedshipment";
import util from "./modules/util";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    auth,
    bankpay,
    packsreceipts,
    relationship,
    assignoperators,
    controlpacks,
    controlinetpays,
    subscribers,
    subscribercard,
    payment,
    infopack,
    packs,
    gridcontextmenu,
    errorpayments,
    acceptedShipment,
    util
  }
});
